import { Injectable } from '@angular/core';
import { IExceptionTelemetry, ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppInsightService {
  appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) { // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  
  logException(exception: Error, properties?: { [key: string]: any}, severityLevel?: number) {
    const exceptionTelemetry: IExceptionTelemetry = {
      exception: exception,
      severityLevel: severityLevel,
      properties: properties
    };
    //this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
    this.appInsights.trackException(exceptionTelemetry);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message: message }, properties);
  }
}